export type BusSearchResult = {
	cl: number;
	lc: boolean;
	lt: string;
	sl: number;
	tl: number;
	tp: string;
	ts: string;
	cd: string;
	ct: number;
};

const abreviations: Record<string, string> = {
	jardim: 'jd',
	terminal: 'term',
	estacao: 'est',
	santo: 'sto',
	parque: 'pq',
	cidade: 'cid',
	conde: 'cde',
	chacara: 'chac',
	largo: 'lgo',
};

export default async function searchBus(searchTerm: string) {
	Object.entries(abreviations).forEach(([full, abbr]) => {
		const regex = new RegExp(`\\b${full}\\b`, 'gi');
		searchTerm = searchTerm.replace(regex, abbr);
	});

	const response = await fetch(
		encodeURI(`/api-proxy/data/Linha/Buscar?termosBusca=${searchTerm}`),
		{ headers: { 'Content-Type': 'application/json' } },
	);

	if (!response.ok) return [];

	const data = (await response.json()) as BusSearchResult[];

	return data;
}
